export default class PopupVideos {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.closeEl = this.root.querySelector('[data-popup-video-close]');
        this.posterEl = this.root.querySelector('[data-popup-video-poster]');
        this.videoEl = this.root.querySelector('[data-popup-video-video]');
        this.playEl = this.root.querySelector('[data-popup-video-play]');
        this.container = this.root.querySelector(
            '[data-popup-video-container]'
        );
        return true;
    }

    init() {
        this.setClose();
        this.setPlay();
        this.setVideoTapToggle();
        this.setOutsideTapToHidePlay();
    }

    showPopup() {
        if (!this.root) return;
        this.root.classList.remove('hidden');
        this.root.classList.add('opacity-0');
        this.container.classList.add('translate-y-8');
        setTimeout(() => {
            this.root.classList.add('opacity-100');
            this.root.classList.remove('opacity-0');
            this.container.classList.add('translate-y-0');
            this.container.classList.remove('translate-y-8');
        }, 10);
    }

    setClose() {
        if (!this.closeEl) return;

        this.closeEl.addEventListener('click', () => {
            this.root.classList.add('opacity-0');
            this.root.classList.remove('opacity-100');
            this.container.classList.remove('translate-y-0');
            this.container.classList.add('translate-y-8');

            if (this.videoEl) {
                this.videoEl.pause();
                this.videoEl.currentTime = 0;
            }

            if (this.playEl) {
                const iconEl = this.playEl.querySelector('[video-button-icon]');
                const textEl = this.playEl.querySelector('[video-button-text]');
                if (iconEl && textEl) {
                    textEl.innerHTML = iconEl.getAttribute('video-play-txt');
                    iconEl.classList.add('icon-play');
                    iconEl.classList.remove('icon-pause');
                    this.playEl.classList.remove('hidden!');
                    this.playEl.classList.remove('group-hover:flex!');
                }
            }

            setTimeout(() => {
                this.root.classList.add('hidden');
                this.posterEl.classList.remove('hidden');
                this.videoEl.classList.add('hidden');
                this.playEl.classList.remove('hidden!');
            }, 500);
        });
    }

    setPlay() {
        if (!this.playEl) return;
        this.playEl.addEventListener('click', event => {
            this.toggleVideo(event);
        });
    }

    setPoster(url) {
        if (!url || !this.posterEl) return;
        this.posterEl.src = url;
    }

    setVideo(url) {
        if (!url || !this.videoEl) return;
        this.videoEl.src = url;
    }

    toggleVideo(event) {
        if (!this.videoEl) return;
        const { currentTarget } = event;
        const iconEl = currentTarget.querySelector('[video-button-icon]');
        const textEl = currentTarget.querySelector('[video-button-text]');

        this.posterEl.classList.add('hidden');
        this.videoEl.classList.remove('hidden');

        if (this.videoEl.paused) {
            this.videoEl.play().then(() => {
                textEl.innerHTML = iconEl.getAttribute('video-stop-txt');
                iconEl.classList.remove('icon-play');
                iconEl.classList.add('icon-pause');

                currentTarget
                    .closest('[data-popup-video-container]')
                    .classList.add('group');
                currentTarget.classList.add('hidden!');
                currentTarget.classList.add('group-hover:flex!');
            });
        } else {
            this.videoEl.pause();
            textEl.innerHTML = iconEl.getAttribute('video-play-txt');
            iconEl.classList.add('icon-play');
            iconEl.classList.remove('icon-pause');
            currentTarget
                .closest('[data-popup-video-container]')
                .classList.remove('group');
            currentTarget.classList.remove('hidden!');
            currentTarget.classList.remove('group-hover:flex!');
        }
    }

    setVideoTapToggle() {
        if (!this.videoEl || !this.playEl) return;

        // Use 'touchstart' for mobile (optional: 'click' for fallback)
        this.videoEl.addEventListener('touchstart', () => {
            this.playEl.classList.toggle('hidden!');
            this.playEl.classList.toggle('group-hover:flex!');
        });

        // Optional fallback for desktop
        this.videoEl.addEventListener('click', () => {
            if (window.innerWidth <= 768) {
                // Only on small screens
                this.playEl.classList.toggle('hidden!');
                this.playEl.classList.toggle('group-hover:flex!');
            }
        });
    }

    setOutsideTapToHidePlay() {
        if (!this.root || !this.videoEl || !this.playEl) return;

        this.root.addEventListener('touchstart', event => {
            if (
                !this.videoEl.contains(event.target) &&
                !this.playEl.contains(event.target)
            ) {
                this.playEl.classList.add('hidden!');
                this.playEl.classList.remove('group-hover:flex!');
            }
        });

        this.root.addEventListener('click', event => {
            if (window.innerWidth <= 768) {
                if (
                    !this.videoEl.contains(event.target) &&
                    !this.playEl.contains(event.target)
                ) {
                    this.playEl.classList.add('hidden!');
                    this.playEl.classList.remove('group-hover:flex!');
                }
            }
        });
    }
}
